import { useMutation } from '@tanstack/react-query';
import { ApiClient, useApiClient } from 'api/context-provider/useApiClient';
import { ApiError, InferFetchData, throwOnError } from 'api/helpers';
import { operations } from 'api/schema';

export type UpdateLegalDocumentMutationData = NonNullable<operations['updateLegalDocumentVersions']['requestBody']>['content']['application/json'];

async function updateLegalDocumentVersion(apiClient: ApiClient, id: number, body: UpdateLegalDocumentMutationData) {
  return apiClient.PUT('/op/v2/legal-document-versions/{id}', { params: { path: { id } }, body });
}

export default function useUpdateLegalDocumentVersion(id: number) {
  const apiClient = useApiClient();
  return useMutation<InferFetchData<typeof updateLegalDocumentVersion>, ApiError, UpdateLegalDocumentMutationData>({
    mutationKey: ['UpdateLegalDocumentVersion'],
    mutationFn: (data) => {
      return throwOnError(updateLegalDocumentVersion(apiClient, id, data));
    },
  });
}
